<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'OpenpayView',

  props: {},

  data () {
    return {
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
    if (this.$route.query.id) {
      this.goTo('myTransactions')
      this.setNotification({ color: 'success', message: this.$t('cardPaymentSuccess') })
    }
  }
}
</script>
